import {createContext} from 'react'
import {AsyncValue} from '@kensho/tacklebox'

import {PricingResponse} from '../api/usePricing'

export default createContext<AsyncValue<PricingResponse[]> | null>(null)
